// removed by extract-text-webpack-plugin
module.exports = {"nav":"src-components-Nav----nav-module---nav---3nUyG","link":"src-components-Nav----nav-module---link---3UnCc","linkLight":"src-components-Nav----nav-module---linkLight---2anRw","linkDark":"src-components-Nav----nav-module---linkDark---2fRiu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/nav.module.scss
// module id = 333
// module chunks = 168707334958949